/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import GetPayHistoryActionBox from '../ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import './tables_styles.css';
import EmployeeNamePic from '../EmployeeNamePic/EmployeeNamePic';

import OvertimeARModalController from '../../Modals/ActionRequiredModals/OvertimeARModal/OvertimeARModalController';
import { useAppSelector } from '../../../infra/hooks';
import { actionRequiredService } from '../../../api/services/actionRequiredService';
import _ from 'lodash';
import { themes } from '../../themes/themes';
import { useTranslate } from '../../../hooks';
import { arabicDataGrid } from '../../helper';

interface Propval {
  trans: any;
}

const Overtime = ({ trans }: Propval) => {
  const [openModal, setOpenModal] = useState(false);
  const [fullData, setFullData] = useState<any>({});
  const [historyData, setHistoryData] = useState<any>({});
  const getStatus = ['Pending', 'Approved', 'Rejected'];

  const storedARData = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredData,
  );

  const tableColumns: any = [
    {
      field: 'empId',
      headerName: trans('Emp Id'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'empName',
      headerName: trans('Emp Name'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => {
        return <EmployeeNamePic name={params?.row?.empName} picture="" />;
      },
    },
    {
      field: 'department',
      headerName: trans('Department'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'totalAmount',
      headerName: trans('Total Amount'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'totalHours',
      headerName: trans('Total Hours'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },

    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        if (params?.row?.status == 0) {
          return (
            <GetPayHistoryActionBox
              onView={() => {
                handleTransferView(params?.row?.fullData);
                setOpenModal(true);
              }}
            />
          );
        } else {
          return (
            <Typography
              style={{
                fontSize: '14px',
                color: themes.greyDefault_500,
              }}
            >
              {getStatus[params?.row?.status]}
            </Typography>
          );
        }
      },

      width: 200,
      height: 70,
    },
  ];

  const getComplaintHistoryCall = (empId: any, companyId: any) => {
    actionRequiredService
      .getClaimHistory(empId, companyId)
      .then((result) => {
        setHistoryData(result?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleTransferView = (complaint: any) => {
    setFullData(complaint);
    getComplaintHistoryCall(complaint.emp_id, complaint.company_id);
  };

  const row_data = _.map(storedARData, (data: any) => {
    return {
      id: data?.id,
      empId: `#${data?.staff_id}`,
      empName: `${data?.first_name} ${data?.last_name}`,
      department: data?.department_name,
      totalAmount: data?.amount,
      totalHours: data?.hours,
      fullData: data,
      status: data?.overtime_status,
    };
  });

  const { isRTL } = useTranslate();

  return (
    <>
      <Box
        className="ar_table"
        sx={{
          '& .header': {
            backgroundColor: '#F5F5F5',
          },

          width: '100%',
          marginTop: '2em',
        }}
      >
        <DataGrid
          sx={{
            color: '#081735',
            font: 'normal normal normal 14px/24px Lato;',
          }}
          autoHeight
          disableExtendRowFullWidth
          disableColumnMenu
          localeText={isRTL ? arabicDataGrid : undefined}
          disableSelectionOnClick
          rows={row_data}
          columns={tableColumns}
          componentsProps={{
            pagination: {
              labelRowsPerPage: trans('Rows per page'),
            },
          }}
        />
      </Box>
      {openModal && (
        <OvertimeARModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          fullData={fullData}
          historyData={historyData}
        />
      )}
    </>
  );
};

export default Overtime;
